// Sales Javascript

document.addEventListener('DOMContentLoaded', function () {
    function getRandomSalesCount(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }
    function getRandomSalesTime(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }
    function updateSalesNotification() {
      const salesCount = getRandomSalesCount(2, 10);
      const timePeriod = getRandomSalesTime(2, 24);
      document.getElementById('sales-count').textContent = salesCount;
      document.getElementById('time-period').textContent = `${timePeriod} hours`;
    }
    updateSalesNotification();
   // setInterval(updateSalesNotification, 30000);
});

// View Javascript

document.addEventListener("DOMContentLoaded", function () {
  const viewCountElement = document.getElementById("view-count");
  function updateViewCount() {
    const min = 5;
    const max = 10;
    const randomViewers = Math.floor(Math.random() * (max - min + 1)) + min;
    viewCountElement.textContent = randomViewers;
  }
  updateViewCount();
  setInterval(updateViewCount, 3000);
});

// Read More & Read Less Javascript

document.addEventListener("DOMContentLoaded", function () {
  const readMoreButtons = document.querySelectorAll(".readmore_btn");
  readMoreButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const toggleDiv = button.previousElementSibling;
      if (toggleDiv) {
        toggleDiv.classList.toggle("readmore_text");
        button.classList.toggle("toggle-active");
        if (button.textContent.trim() === "See all Information") {
          button.textContent = "Hide Less Information";
        } else {
          button.textContent = "See all Information";
        }
      }
    });
  });
});

// product card link
document.querySelectorAll('.custm_link_url').forEach(function(element) {
  element.addEventListener('click', function() {
    var urlLink = this.querySelector('.custm-link')?.getAttribute('href');
    if (urlLink) {
      window.location.href = urlLink;
    }
  });
});
// document.addEventListener("DOMContentLoaded", () => {
//   const mediaContainers = document.querySelectorAll(".media-container");

//   mediaContainers.forEach((container) => {
//     const productMedia = container.querySelector(".product-image");
//     const variantLinks = container.querySelectorAll(".variant-link");

//     variantLinks.forEach((link) => {
//       link.addEventListener("click", (event) => {
//         event.preventDefault();
//         // Get the new image source from the data attribute
//         const newImageSrc = link.getAttribute("data-image-src");
//         console.log(newImageSrc);
//         // Update the product media image
//         if (productMedia && newImageSrc) {
//           productMedia.src = newImageSrc;
//         }
//       });
//     });
//   });
// });

$(document).ready(function() {
  $('.variant-image').click(function() {
   var imageSrc =  $(this).find('img').attr('src');
    // console.log('>>>>',imageSrc);
   $(this).parents('.card-wrapper').find('.media img').attr('src',imageSrc);
   $(this).parents('.card-wrapper').find('.media img').attr('srcset',imageSrc);
   
  })
});
